module.exports = __webpack_public_path__ + "media/identify/icon_fifth-4579cc77.svg";